// composables/usePedidoDraft.js
// Persiste el borrador del wizard de nuevo pedido.
// localStorage  → form + items (JSON, síncrono, ligero)
// IndexedDB     → archivo PDF (binario, asíncrono)

const LS_KEY    = "divisan_pedido_draft"
const IDB_NAME  = "divisan_drafts"
const IDB_STORE = "pdfs"
const IDB_KEY   = "pedido_nuevo"

// ── localStorage — form + items ──────────────────────────

export function guardarDraftLS(formPedido, items) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify({
      formPedido,
      // Persistir solo campos de datos, no estado de UI (_abierto, _busqueda)
      items: items.map(({ articulo_id, cantidad, notas, _desdeIa,
                          nombre_pdf, codigo_pdf, comentarios, confianza }) => ({
        articulo_id, cantidad, notas: notas || "",
        _desdeIa:    _desdeIa    || false,
        _busqueda:   "",
        _abierto:    false,
        nombre_pdf:  nombre_pdf  || null,
        codigo_pdf:  codigo_pdf  || null,
        comentarios: comentarios || [],
        confianza:   confianza   ?? 100,
      })),
      ts: Date.now(),
    }))
  } catch (e) {
    console.warn("[draft] localStorage:", e)
  }
}

export function cargarDraftLS() {
  try {
    const raw = localStorage.getItem(LS_KEY)
    return raw ? JSON.parse(raw) : null   // { formPedido, items, ts }
  } catch { return null }
}

export function limpiarDraftLS()  { localStorage.removeItem(LS_KEY) }
export function hayDraftLS()      { return !!localStorage.getItem(LS_KEY) }

// ── IndexedDB — archivo PDF ───────────────────────────────

function abrirIDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(IDB_NAME, 1)
    req.onupgradeneeded = (e) => e.target.result.createObjectStore(IDB_STORE)
    req.onsuccess = (e) => resolve(e.target.result)
    req.onerror   = (e) => reject(e.target.error)
  })
}

export async function guardarPdfIDB(file) {
  if (!file) return
  try {
    // Leer el buffer ANTES de abrir la transacción IDB.
    // Un await dentro de una transacción activa la cierra (IDB es síncrono internamente).
    const buf = await file.arrayBuffer()
    const db  = await abrirIDB()
    const tx  = db.transaction(IDB_STORE, "readwrite")
    tx.objectStore(IDB_STORE).put({ buf, name: file.name, type: file.type }, IDB_KEY)
    await new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = rej })
    db.close()
  } catch (e) { console.warn("[draft] IDB write:", e) }
}

export async function cargarPdfIDB() {
  try {
    const db   = await abrirIDB()
    const tx   = db.transaction(IDB_STORE, "readonly")
    const data = await new Promise((res, rej) => {
      const req = tx.objectStore(IDB_STORE).get(IDB_KEY)
      req.onsuccess = (e) => res(e.target.result)
      req.onerror   = (e) => rej(e.target.error)
    })
    db.close()
    if (!data) return null
    return new File([data.buf], data.name, { type: data.type })
  } catch (e) { console.warn("[draft] IDB read:", e); return null }
}

export async function limpiarPdfIDB() {
  try {
    const db = await abrirIDB()
    const tx = db.transaction(IDB_STORE, "readwrite")
    tx.objectStore(IDB_STORE).delete(IDB_KEY)
    await new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = rej })
    db.close()
  } catch (e) { console.warn("[draft] IDB delete:", e) }
}

// Limpia todo — llamar al guardar exitoso o al descartar
export async function limpiarTodoDraft() {
  limpiarDraftLS()
  await limpiarPdfIDB()
}